import Image from "next/image";
import React, { useEffect, useState } from "react";
import { GoArrowUpRight } from "react-icons/go";
import { container_classname } from "./new-ui/constants";

interface AutomationToolBenefitsCard {
    title: string;
    description: string;
    imageUrl: string;
}

export interface AutomationToolBenefitsProps {
    title: string;
    ProcessSteps: AutomationToolBenefitsCard[];
}

const defaultautomationToolBenefitsData: AutomationToolBenefitsProps = {
    title: "How to integrate WhatsApp payments in 4 easy steps?",
    ProcessSteps: [
        {
            title: "Go to Integrations tab",
            description: "Go to Integrations → Payments in the Gallabox Dashboard and select the payment gateway.",
            imageUrl: "/integration/payment-link.png",
        },
        {
            title: "Name your Integration",
            description: "Name your integration and initiate the connection with your payment gateway.",
            imageUrl: "/integration/payment-update.png",
        },
        {
            title: "Authorize Gallabox",
            description: "Permit Gallabox to connect with your preferred payment gateway.",
            imageUrl: "/integration/personalize-broadcast.png",
        },
        {
            title: "Configure the settings",
            description: "Choose your preferred WhatsApp channel and configure it.",
            imageUrl: "/integration/travelcation.png",
        },
    ],
};

const AUTO_ADVANCE_INTERVAL = 7000;

const AutomationToolBenefitsDesktop: React.FC<{ automationToolBenefits?: AutomationToolBenefitsProps }> = ({ automationToolBenefits = defaultautomationToolBenefitsData }) => {
    const { title, ProcessSteps } = automationToolBenefits;
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % ProcessSteps.length);
        }, AUTO_ADVANCE_INTERVAL);

        return () => clearInterval(interval);
    }, [ProcessSteps.length]);

    const toggleAccordion = (index: number) => {
        setCurrentIndex(index);
    };

    return (
        <section className="py-20 lg:block hidden" style={{ background: "var(--light-grad-1, linear-gradient(103deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.43%))" }}>
            <h2 className="md:text-6xl text-4xl font-semibold text-left px-5 pb-10 max-w-7xl mx-auto" style={{ fontFamily: "Degular Display" }}>
                {title}
            </h2>
            <div className={`${container_classname} flex md:flex-row flex-col md:gap-x-24`}>
                <div className="faq-section md:w-1/2 w-full">
                    {ProcessSteps.map((item, index) => (
                        <div key={index} className={`faq-accordion-item ${currentIndex === index ? "faq-active" : ""}`}>
                            <div className="faq-border-top-animation" />
                            <h3 className="faq-accordion-header text-lg font-medium cursor-pointer flex justify-between my-5" onClick={() => toggleAccordion(index)}>
                                {item.title}
                                <span
                                    className={`${currentIndex === index ? "rotated" : ""}`}
                                    style={{
                                        flexShrink: 0,
                                        transition: "transform 0.4s ease",
                                    }}
                                >
                                    <GoArrowUpRight />
                                </span>
                            </h3>
                            {currentIndex === index && (
                                <div className="faq-accordion-content mb-5">
                                    <p className="mt-2">{item.description}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className="md:w-1/2 w-full flex items-center justify-center">
                    {ProcessSteps[currentIndex] && (
                        <Image src={ProcessSteps[currentIndex].imageUrl} width={400} height={400} alt="Process step illustration" className="mt-5 max-w-full h-auto" />
                    )}
                </div>
            </div>
        </section>
    );
};

export default AutomationToolBenefitsDesktop;
